import { render, staticRenderFns } from "./SampleValue.vue?vue&type=template&id=dce3a936&scoped=true&"
import script from "./SampleValue.vue?vue&type=script&lang=js&"
export * from "./SampleValue.vue?vue&type=script&lang=js&"
import style0 from "./SampleValue.vue?vue&type=style&index=0&id=dce3a936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce3a936",
  null
  
)

export default component.exports